import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { AssetConstituentModal } from '../../../components/core-v2/organisms/asset-constituent-modal/asset-constituent-modal'
import { ConstituentAsset } from '../../../components/core-v2/organisms/asset-lookthrough-table'
import { makeForExRateFn } from '../../../utilities/fx'
import { useAppSelector } from '../store/hooks'
import AssetLookThroughStateless from '../templates/asset-look-through-stateless'

export const AssetLookThroughPage = () => {
  const form = useForm({ defaultValues: { region: 'all', trades: 'all', displayInZAR: true } })
  const state = useAppSelector(x => x.gapRisk)

  const [selectedConstituents, setSelectedConstituents] = useState<ConstituentAsset[]>(undefined)
  const [selectedInstrumentName, setSelectedInstrumentName] = useState('')

  const onAssetClick = (code: string) => {
    const constituents: ConstituentAsset[] = []
    state.assetConstituents?.forEach(assetConstituent => {
      const apiConstituents = assetConstituent.constituentAssets?.filter(item => item.isin === code)
      if (apiConstituents && apiConstituents.length > 0) {
        setSelectedInstrumentName(apiConstituents[0].instrumentLongName)
      }
      apiConstituents.forEach(apiConstituent => {
        constituents.push({
          amountInvestedWithGapRisk: apiConstituent.amountInvestedWithGapRisk,
          amountInvestedWithoutGapRisk: apiConstituent.amountInvestedWithoutGapRisk,
          aum: apiConstituent.aum,
          currency: apiConstituent.currency,
          code: assetConstituent.assetId,
          name: assetConstituent.assetName
        } as ConstituentAsset)
      })
    })
    setSelectedConstituents(constituents)
  }

  const isModalOpen = selectedConstituents?.length > 0
  return (
    <FormProvider {...form}>
      <AssetLookThroughStateless
        assetConstituents={state.assetConstituents}
        fxRateConversionFn={makeForExRateFn(state.fxConversionRates)}
        isLoading={state.isLoading}
        onAssetClick={onAssetClick}
      />
      <AssetConstituentModal
        data={selectedConstituents}
        header={selectedInstrumentName}
        isOpen={isModalOpen}
        onClose={() => setSelectedConstituents(undefined)}
      />
    </FormProvider>
  )
}
